<ng-template #customGroupTemplate>
    <form class="builder" [formGroup]="form" autocomplete="off">
        <div class="form-group row">
            <label class="col-sm-3 col-form-label">Group name </label>
            <input
                [ngClass]="{ error: form.controls.name.invalid && showError }"
                name="name"
                formControlName="name"
                class="form-control col-sm-7"
            />
        </div>

        <cm-inline-error
            *ngIf="form.invalid && showError"
            [errorMessages]="['Please fill in all required fields']"
            class="align-center"
        ></cm-inline-error>
    </form>
    <div class="modal-footer">
        <button type="button" class="btn btn-default" (click)="close()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="save()">SAVE</button>
    </div>
</ng-template>
